import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'
import { CircleLoader } from 'components/loaders'

/* eslint-disable */
import styles from './button.styl'
/* eslint-enable */

export default class Button extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    style: PropTypes.object,
    small: PropTypes.bool,
    tiny: PropTypes.bool,
    isLoading: PropTypes.bool,
    secondary: PropTypes.bool,
    tertiary: PropTypes.bool,
    negative: PropTypes.bool,
    link: PropTypes.bool,
    disabled: PropTypes.bool,
    fluid: PropTypes.bool,
    justify: PropTypes.bool,
    icon: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    intlKey: PropTypes.string,
    appendComponent: PropTypes.node,
    className: PropTypes.string,
    type: PropTypes.string
  }
  static defaultProps = {
    className: '',
    type: 'submit',
    disabled: false,
    link: false,
    fluid: false,
    justify: false,
    appendComponent: null,
    onClick: () => {},
    isLoading: false,
    icon: '',
    small: false
  }

  renderContent = () => {
    const {
      isLoading = false,
      children,
      secondary,
      tertiary,
      icon,
      intlKey,
      appendComponent
    } = this.props

    const translatedContent = intlKey
      ? (<FormattedMessage
          id={intlKey}
          defaultMessage={typeof children === 'string' ? children : ''}
        />)
      : children

    const content = icon
      ? (<span>
          <span className={`ico ico--${icon} btn-icon`} />
          {translatedContent}
        </span>)
      : translatedContent
    const white = !secondary && !tertiary

    return (
      <span>
        <div className={`${styles.content} ${isLoading ? styles.loading : ''}`}>
          {content}
          {appendComponent}
        </div>
        {isLoading &&
          <div className={styles.loader}>
            <CircleLoader white={white} size={40} />
          </div>}
      </span>
    )
  }

  render() {
    const {
      className,
      style,
      disabled,
      onClick,
      type = 'submit',
      secondary,
      tertiary,
      negative,
      icon,
      small,
      tiny,
      justify,
      fluid,
      link,
      isLoading
    } = this.props

    /* eslint-disable */
    return (
      <button
        type={type}
        style={style}
        className={cx('btn', className, {
          ['disabled']: disabled,
          ['secondary']: secondary,
          ['tertiary']: tertiary,
          ['negative']: negative,
          ['link']: link,
          ['with-icon']: icon && !tertiary,
          ['small']: small,
          ['tiny']: tiny,
          ['justify']: justify,
          ['fluid']: fluid
        })}
        onClick={onClick}
        disabled={disabled || isLoading}
      >
        {this.renderContent()}
      </button>
    )
    /* eslint-enable */
  }
}
